import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { styled } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { KeyboardKey } from "_shared/_utilities/keyboard-keys";
const ButtonsContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row'
}));

type FilterTextFieldProps = {
  filterName: string;
  placeholder: string;
  value: string;
  onChange: (filterName: string, value: string) => void;
};

export default function FilterTextField(props: Readonly<FilterTextFieldProps>) {
  const { filterName, placeholder, onChange, value: appliedValue } = props;

  const [draft, setDraft] = React.useState<string>(appliedValue);

  function getButtons() {
    if (draft === appliedValue) return null;
    
    return (
      <ButtonsContainer>
        <IconButton 
          size="small" 
          disabled={draft === ''}
          onClick={() => onChange(filterName, draft)}
        >
          <CheckIcon fontSize="small" />
        </IconButton>
        <IconButton 
          size="small" 
          onClick={() => setDraft(appliedValue)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </ButtonsContainer>
    )
  }

  return (
    <TextField
      name={filterName}
      size="small"
      multiline
      value={draft}
      placeholder={placeholder}
      variant="outlined"
      sx={{ width: '100%' }}
      slotProps={{
        input: {
          endAdornment: getButtons()
        }
      }}
      onKeyDown={(event) => {
        if (event.key === KeyboardKey.Enter) {
          event.preventDefault();
          onChange(filterName, draft);
        }
        if (event.key === KeyboardKey.Escape) {
          event.preventDefault();
          setDraft(appliedValue);
        }
      }}
      onChange={(event) => {
        setDraft(event.target.value);
      }}
    />
  )
}
